export enum AssistBillingTypes {
  MensalidadeAssistPro = "MensalidadeAssistPro",
  ContatosAssistPro = "ContatosAssistPro",
  MensalidadeAssistProProporcional = "MensalidadeAssistProProporcional",
  AbonoMensalidadeAssistProProporcional = "AbonoMensalidadeAssistProProporcional",
  AbonoMensalidadeAssistPro = "AbonoMensalidadeAssistPro",
  AbonoContatosAssistPro = "AbonoContatosAssistPro",
}
